import { useState, useEffect, useCallback } from 'react';

import { useAuthUser } from './authUser';
import { getGhostedUsername, useStoreGhostedUsername } from './ghostedUser';
import { useAuthEventDispatch } from './events';
import { useTrackEvent } from 'shared/utils/useTrackEvent';

export { AMPLIFY_AUTH_EVENT } from './events';

export function useEffectiveUser() {
  const authUser = useAuthUser();
  const trackEvent = useTrackEvent();
  const [ghostedUsername, setGhostedUsername] = useState(getGhostedUsername);
  const [user, setUser] = useState();
  const [password, setPassword] = useState();
  const [effectiveUser, setEffectiveUser] = useState();
  const [role, setRole] = useState();
  const assign = useCallback(
    ({
      email,
      firstName,
      lastName,
      userId,
      accountId,
      accountType,
      userType,
      organizationName,
      organizationLogoUrl,
      organizationLogo,
      userLogo,
      visibility,
      newProgramVisibility,
      features,
    }) => {
      const isGhosted = email && email !== authUser?.username;
      const user = {
        email: email || authUser?.username,
        givenName: firstName,
        familyName: lastName,
        'custom:user_id': userId,
        'custom:account_id': accountId,
        'custom:type': userType,
        organizationName,
        organizationLogoUrl,
        organizationLogo,
        userLogo,
        visibility,
        newProgramVisibility,
        features: features || {},
      };
      trackEvent(
        'User Logged In',
        {
          ...user,
          name: `${firstName} ${lastName}${isGhosted ? ' (Ghosted)' : ''}`,
          ghostedBy: isGhosted ? authUser?.username : undefined,
          accountType,
          organizationId: accountId,
        },
        { identify: true },
      );
      //    setRole(accountId === '1' ? 'superAdmin' : accountType)
      setRole(accountType);
      setEffectiveUser({
        attributes: user,
      });
    },
    [authUser?.username, trackEvent],
  );

  useAuthEventDispatch();
  useStoreGhostedUsername(ghostedUsername);
  useEffect(() => {
    setUser({
      role,
      authUser,
      ghostedUsername,
      effectiveUser,
      attributes: effectiveUser && effectiveUser.attributes,
      password,
      signInAs: setGhostedUsername,
      setPassword,
      assign,
    });
  }, [role, authUser, effectiveUser, password]);

  return user;
}
